export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/handpick.846859cf.svg","height":19,"width":15,"blurWidth":0,"blurHeight":0};